import * as React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import { WmkImage } from "wmk-image";
import { WmkLink } from "wmk-link";
import { IconBlock as IconBlockClass } from "../../classes/IconBlock";
import { colors } from "./colors";
import { Typography } from "./Typography";
import { buttonStyles } from "./Buttons/WmkButton";

const IconBlockContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
  padding-top: 2.5rem;
  color: ${colors.gray.getHex()};
  .icon-row {
    display: flex;
    justify-content: space-around;
    padding: 0 5vw 5rem;
  }
  @media screen and (min-width: 991px) {
    .icon-row {
      padding: 0 0 5rem;
    }
  }
`;

const CtaBlockContainer = styled(Container)`
  padding: 5rem 20vw;
  background: ${colors.darkPurple.getHex()};
  color: white;
  .header-col {
    margin: 0 0 5rem;
  }
  a {
    text-decoration: none;
    p {
      ${buttonStyles};
      text-align: center;
    }
  }
  .link-col {
    display: flex;
    justify-content: space-around;
  }
  .title-col {
    margin-bottom: 2rem;
  }
  @media screen and (max-width: 767px) {
    padding: 5rem 10vw;
  }
`;

const IconCol = styled(Col)`
  text-align: center;
  padding: 1rem;
  margin: 1rem;
  align-items: center;
  .gatsby-image-wrapper {
    // margin: 2rem;
    width: 100px;
  }
  img {
    // max-width: 100px;
  }
  display: flex;
  flex-direction: column;
  justify-content: flex-top;
  // padding: 0;
  margin: 0;
  .icon-text {
    font-size: 20px !important;
    margin-top: 1rem;
  }
  @media screen and (min-width: 991px) {
    padding: 2rem;
    .gatsby-image-wrapper {
      margin: 0 25%;
      width: auto;
    }
    .icon-text {
      
      font-size: 24px !important;
    }
  }
`;

export const IconBlock = ({
  iconBlockData
}: {
  iconBlockData: IconBlockClass;
}) => {
  return (
    <IconBlockContainer fluid>
      <Row style={{ marginRight: 0, marginLeft: 0 }}>
        <Col className="header-col">
          <Typography.H2 style={{ textAlign: "center" }}>
            {iconBlockData?.title}
          </Typography.H2>
        </Col>
      </Row>
      <Row className="icon-row" style={{ marginRight: 0, marginLeft: 0 }}>
        {Array.isArray(iconBlockData?.iconSnippets) &&
          iconBlockData.iconSnippets.map((snippet, i) => {
            return (
              <IconCol key={`snippet ${i}`} lg={3} md={3} sm={5} xs={7}>
                <WmkImage image={snippet.icon} />
                <Typography.P className="icon-text">
                  {snippet.descriptor}
                </Typography.P>
              </IconCol>
            );
          })}
      </Row>
      <CtaBlockContainer fluid>
        <Row>
          <Col className="title-col">
            <Typography.H2 style={{ textAlign: "center", fontSize: "45px" }}>
              {iconBlockData?.ctaHeadline}
            </Typography.H2>
          </Col>
        </Row>
        <Row>
          <Col className="link-col">
            <WmkLink
              to={
                iconBlockData?.ctaLink?.path.includes("http")
                  ? `${iconBlockData?.ctaLink?.path}`
                  : `/${iconBlockData?.ctaLink?.path}`
              }>
              <p>{iconBlockData?.ctaLink?.linkText}</p>
            </WmkLink>
          </Col>
        </Row>
      </CtaBlockContainer>
    </IconBlockContainer>
  );
};
